import { render, staticRenderFns } from "./onebox-redirectevaluate.vue?vue&type=template&id=06572b2f&"
import script from "./onebox-redirectevaluate.vue?vue&type=script&lang=js&"
export * from "./onebox-redirectevaluate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports